import React, { useState, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box } from "@material-ui/core";
import useStyles from "../common/Styles";
import { useSelector } from "react-redux";
import { toolbarHeight } from "components/app/Styles";
import { filterContainerHeight, chartTitleHeight } from "../common/Styles";
import { getWindowSize, convertToINS } from "../common/utils";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";


function TribesStackBar() {
    const classes = useStyles();
    const { tribal_shortage } = useSelector((state) => state.water_user);
    const { isMobile } = useGetViewPortDimensions();
  
    const [windowSize, setWindowSize] = useState(getWindowSize());

    // const fakeMaxForColumn = 1000;
    // const waterAvailable = useRef(Math.ceil(fakeMaxForColumn / 1000) * 1000);

    //gets windowSize to set width of barchart
    useEffect(() => {
        const handleWindowResize = () => {
        setWindowSize(getWindowSize());
        };
        window.addEventListener("resize", handleWindowResize);
        return () => {
        window.removeEventListener("resize", handleWindowResize);
        };
    }, []);

    let categories = [];
    tribal_shortage.total_water.map((water) => {
      categories.push(convertToINS(water));
      return water
    });

    const options = {
        chart: {
          type: "column",
          // plotBackgroundColor: "#97B0DC",
          // plotBackgroundColor: "#E5E9EE",
          backgroundColor: "#E5E9EE",
          width: isMobile ? 380 : windowSize.innerWidth - 500,
          height:
            windowSize.innerHeight -
            toolbarHeight -
            filterContainerHeight -
            chartTitleHeight -
            75 -
            //slider height
            66,
        },
        title: {
          text: undefined,
        },
        series: [
          {
            name: "NIA",
            data: tribal_shortage.nia,
            color: "#2352D0",
          },
          // {
          //   name: "NIA A",
          //   data: tribal_shortage.nia_a,
          //   color: "#6AA4DC",
          // },
          {
            name: "Indian",
            data: tribal_shortage.indian,
            color: "#6AA4DC",
          },
          {
            name: "M&I",
            data: tribal_shortage.m_i,
            color: "#F3C745",
          },
          {
            name: "P3",
            data: tribal_shortage.p13,
            color: "#DE3E40",
          },
        ],
        plotOptions: {
          column: {
            stacking: "normal",
            states: {
              hover: {
                enabled: false,
              },
              inactive: {
                opacity: 1,
              },
            },
            borderWidth: 0,
            events: {
              legendItemClick: function () {
                return false; // <== returning false will cancel the default action
              },
            },
          },
          series: {
            pointWidth: 100,
          },
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          title: {
            text: "Colorado River Water Available in Central Arizona (acre-feet)",
            style: {
                fontFamily: "Arial",
                fontWeight: "bold",
                fontSize: "16px",
              },
          },
          categories: categories,
          labels: {
            style: {
              fontFamily: "Arial",
              fontWeight: "bold",
              fontSize: "16px",
            },
          },
        },
        yAxis: {
          min: 0,
          // TODO: this number will eventually use the available colorado water for the city -> currently unknown
        //   max: Math.ceil(fakeMaxForColumn / 1000) * 1000,
          title: {
            text: "Colorado River Allocation (acre-feet)",
            margin: 40,
            style: {
              fontFamily: "Arial",
              fontWeight: "bold",
              fontSize: "16px",
            },
          },
          labels: {
            style: {
              fontFamily: "Arial",
              fontWeight: "bold",
              fontSize: "14px",
            },
          },
          gridLineWidth: 1,
          gridLineColor: "#C4C4C4",
        },
        tooltip: {
          enabled: false,
        },
        legend: {
          title: {
            // text: "<span style='font-size:12px; color:#666; font-weight:normal font-family:Arial'>Legend</span>",
            // style: {
            //   fontStyle: "normal",
            // },
          },
          itemStyle: {
            color: "#333333",
            fontSize: "12px",
            fontWeight: "normal",
            fontFamily: "Arial",
          },
          align: "center",
          x: 50,
          backgroundColor: "#FFFFFF",
          borderColor: "#E0E0E0",
          borderWidth: 1,
          borderRadius: 15,
          padding: 10,
          itemMarginTop: 5,
          itemMarginBottom: 5,
          shadow: {
            offsetX: -1,
            offsetY: 3,
            color: "#00000029",
            width: 4,
          },
        },
      };

    return (
    <Box className={classes.chartContainer}>
        <HighchartsReact highcharts={Highcharts} options={options} />
    </Box>
    );

}

export default TribesStackBar;
